import React from 'react'
import { useNavigate } from 'react-router-dom'
import classNames from 'classnames'
import { type CustomIntegration } from '../../../models/CustomIntegration'
import { customIntegrationDetailsPath } from '../../../views/CustomIntegration/constants'
import { CommonCard } from '../../Card/CommonCard'
import { AppCardHeader } from '../../AppCard/AppCardHeader'
import { ManageButton } from '../../Button/IntegrationAndOAuth2AppButtons'

interface CustomIntegrationCardProps {
  customIntegration: CustomIntegration
}

export const CustomIntegrationCard: React.FC<CustomIntegrationCardProps> = ({ customIntegration }) => {
  const { id, name, imageUrl, visibility, active } = customIntegration
  const navigate = useNavigate()

  const aboutPath = customIntegrationDetailsPath(id)
  const managePath = customIntegrationDetailsPath(id, 'details')
  const showPrivateBadge = visibility === 'dev' || visibility === 'internal'

  const handleCardClick = () => {
    navigate(aboutPath)
  }

  return (
    <CommonCard
      onCardClick={handleCardClick}
      header={<AppCardHeader name={name} imageUrl={imageUrl} showPrivateBadge={showPrivateBadge} />}
      description={
        <div className='h-auto d-flex flex-column zocks-gap-0.25'>
          <span className='heading-small zocks-text-gray-900'>{name}</span>
          <span
            className={classNames('d-flex align-items-center zocks-gap-0.25 paragraph-medium', {
              'zocks-text-success': active,
              'zocks-text-gray-600': !active,
            })}
          >
            <i className={classNames('bi fs-6', { 'bi-check-lg': active, 'bi-dash-circle': !active })} />
            {active ? 'Enabled' : 'Disabled'}
          </span>
        </div>
      }
      state={null}
      footer={<ManageButton to={managePath} />}
    />
  )
}
